<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow mt-0">
            <div
              class="card-header card-header-primary negative blue-grad w-50 d-flex"
            >
              <button class="btn btn-sm btn-link" @click="$router.go(-1)">
                <i class="fa fa-chevron-left"></i> {{ $t("message.back") }}
              </button>
              <h4 class="card-title">{{ $t("message.admin.logs") }}</h4>
              <div class="form-group ml-auto">
                <!-- <button class="btn btn-outline-secondary btn-sm" :disabled="items.length==0" @click.prevent="makePdf"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.0002 2C12.5525 2 13.0002 2.44772 13.0002 3L13.0002 12.5858L16.2931 9.29289C16.6837 8.90237 17.3168 8.90237 17.7074 9.29289C18.0979 9.68342 18.0979 10.3166 17.7074 10.7071L12.7074 15.7071C12.5198 15.8946 12.2655 16 12.0002 16C11.735 16 11.4807 15.8946 11.2931 15.7071L6.29314 10.7071C5.90261 10.3166 5.90261 9.68342 6.29314 9.29289C6.68366 8.90237 7.31683 8.90237 7.70735 9.29289L11.0002 12.5858L11.0002 3C11.0002 2.44772 11.448 2 12.0002 2ZM3.00024 14C3.55253 14 4.00024 14.4477 4.00024 15L4.00024 19C4.00024 19.2652 4.1056 19.5196 4.29314 19.7071C4.48067 19.8946 4.73503 20 5.00024 20L19.0002 20C19.2655 20 19.5198 19.8946 19.7073 19.7071C19.8949 19.5196 20.0002 19.2652 20.0002 19L20.0002 15C20.0002 14.4477 20.448 14 21.0002 14C21.5525 14 22.0002 14.4477 22.0002 15L22.0002 19C22.0002 19.7957 21.6842 20.5587 21.1216 21.1213C20.559 21.6839 19.7959 22 19.0002 22L5.00024 22C4.20459 22 3.44153 21.6839 2.87892 21.1213C2.31632 20.5587 2.00024 19.7957 2.00024 19L2.00024 15C2.00024 14.4477 2.44796 14 3.00024 14Z" fill="#333333"/></svg> PDF</button> -->
                <button
                  class="btn btn-outline-secondary btn-sm"
                  :disabled="logs.length == 0"
                  @click.prevent="download_xlsx"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12.0002 2C12.5525 2 13.0002 2.44772 13.0002 3L13.0002 12.5858L16.2931 9.29289C16.6837 8.90237 17.3168 8.90237 17.7074 9.29289C18.0979 9.68342 18.0979 10.3166 17.7074 10.7071L12.7074 15.7071C12.5198 15.8946 12.2655 16 12.0002 16C11.735 16 11.4807 15.8946 11.2931 15.7071L6.29314 10.7071C5.90261 10.3166 5.90261 9.68342 6.29314 9.29289C6.68366 8.90237 7.31683 8.90237 7.70735 9.29289L11.0002 12.5858L11.0002 3C11.0002 2.44772 11.448 2 12.0002 2ZM3.00024 14C3.55253 14 4.00024 14.4477 4.00024 15L4.00024 19C4.00024 19.2652 4.1056 19.5196 4.29314 19.7071C4.48067 19.8946 4.73503 20 5.00024 20L19.0002 20C19.2655 20 19.5198 19.8946 19.7073 19.7071C19.8949 19.5196 20.0002 19.2652 20.0002 19L20.0002 15C20.0002 14.4477 20.448 14 21.0002 14C21.5525 14 22.0002 14.4477 22.0002 15L22.0002 19C22.0002 19.7957 21.6842 20.5587 21.1216 21.1213C20.559 21.6839 19.7959 22 19.0002 22L5.00024 22C4.20459 22 3.44153 21.6839 2.87892 21.1213C2.31632 20.5587 2.00024 19.7957 2.00024 19L2.00024 15C2.00024 14.4477 2.44796 14 3.00024 14Z"
                      fill="#333333"
                    />
                  </svg>
                  Excel
                </button>
              </div>
            </div>
            <div class="card-body px-3" id="excel-table">
              <!-- <router-link :to="{name: 'admin-index'}" class="btn btn-sm btn-outline-primary" >{{$t('message.back')}}</router-link> -->
              <b-table
                :tbody-tr-class="row_class"
                :items="logs"
                :fields="logs_fields"
                :per-page="per_page"
                :current-page="current_page"
              >
                <template v-slot:cell(data)="data">
                  <button
                    class="btn btn-secondary btn-sm"
                    @click="show_log_data(data)"
                  >
                    <i class="fa fa-search-plus"></i>
                  </button>
                </template>
              </b-table>
              <div class="d-flex justify-content-center">
                <b-pagination
                  v-model="current_page"
                  :total-rows="logs_length"
                  :per-page="per_page"
                  aria-controls="my-table"
                ></b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="show_log_details"
      :title="$t('message.admin.data')"
      :hide-footer="true"
    >
      <json-viewer :value="json_data"></json-viewer>
    </b-modal>
  </div>
</template>
<script>
import JsonViewer from "vue-json-viewer";
import * as XLSX from "xlsx/xlsx.mjs";
export default {
  components: { JsonViewer },
  name: "admin-logs",
  mounted() {
    if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
    this.load();
  },
  computed: {
    logs_length() {
      return this.logs.length;
    },
  },
  data() {
    return {
      json_data: "",
      per_page: 20,
      current_page: 0,
      logs: [],
      logs_fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "oper_code",
          label: this.$t("message.admin.oper_code"),
          sortable: true,
        },
        {
          key: "log_date",
          label: this.$t("message.admin.log_date"),
          sortable: true,
        },
        {
          key: "log_source_user_id",
          label: this.$t("message.admin.log_source_user_id"),
          sortable: true,
        },
        {
          key: "log_target_user_id",
          label: this.$t("message.admin.log_target_user_id"),
          sortable: true,
        },
        {
          key: "doc_id",
          label: this.$t("message.admin.doc_id"),
          sortable: true,
        },
        {
          key: "is_error",
          label: this.$t("message.admin.is_error"),
        },
        {
          key: "data",
          label: this.$t("message.admin.data"),
        },
      ],
    };
  },
  methods: {
    download_xlsx() {
      let filename = "logs.xlsx";
      var ws = XLSX.utils.json_to_sheet(this.logs);
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Logs");
      XLSX.writeFile(wb, filename);
    },
    /**
     * determines the class name of the row of the table (necessary to
     * highlight the rows with error)
     */
    row_class(item, type) {
      if (item.is_error) return "bg-warning";
      return "";
    },
    /**
     * shows a modal window with detailed data
     */
    show_log_data(data) {
      if (data.item.log_data.trim() != "")
        this.json_data = JSON.parse(data.item.log_data);
      this.$bvModal.show("show_log_details");
    },
    /**
     * Fetches list of all users, filters only those who is not active and
     * adds to users list
     */
    load() {
      const year = new Date().getFullYear();
      axios.get(window.base + `/account/GetLogs?datestart=${year}-01-01&dateend=${year}-12-31`).then((response) => {
        this.logs = response.data;
      });
    },
    /**
     * @params user_id – user identifier
     * accepts user_id as a param and send request to the backend to
     * lock user registration
     */
    lock_user(user_id) {
      var fd = new FormData();
      fd.append("user_id", user_id);
      axios
        .post(window.base + "/account/LockUser", fd)
        .then((response) => {
          this.load();
          new Noty({
            theme: "light",
            type: "success",
            text: this.$root.$t("message.message.success"),
            timeout: 5000,
          }).show();
        })
        .catch((e) => {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$root.$t("message.message.no_success") + " (" + e + ")",
            timeout: 5000,
          }).show();
        });
    },
  },
};
</script>
<style>
.page-item.active button {
  /* background: #9c27b0 !important; */
  /* color: #fff !important; */
}
</style>
